import { createPlugin } from '@backstage/core-plugin-api';
import { createTechDocsAddonExtension, TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { ExpandableNavigationAddon } from './ExpandableNavigation/ExpandableNavigation.esm.js';
import { ReportIssueAddon } from './ReportIssue/ReportIssue.esm.js';
import { TextSizeAddon } from './TextSize/TextSize.esm.js';
import { LightBoxAddon } from './LightBox/LightBox.esm.js';

const techdocsModuleAddonsContribPlugin = createPlugin({
  id: "techdocsModuleAddonsContrib"
});
const ExpandableNavigation = techdocsModuleAddonsContribPlugin.provide(
  createTechDocsAddonExtension({
    name: "ExpandableNavigation",
    location: TechDocsAddonLocations.PrimarySidebar,
    component: ExpandableNavigationAddon
  })
);
const ReportIssue = techdocsModuleAddonsContribPlugin.provide(
  createTechDocsAddonExtension({
    name: "ReportIssue",
    location: TechDocsAddonLocations.Content,
    component: ReportIssueAddon
  })
);
const TextSize = techdocsModuleAddonsContribPlugin.provide(
  createTechDocsAddonExtension({
    name: "TextSize",
    location: TechDocsAddonLocations.Settings,
    component: TextSizeAddon
  })
);
const LightBox = techdocsModuleAddonsContribPlugin.provide(
  createTechDocsAddonExtension({
    name: "LightBox",
    location: TechDocsAddonLocations.Content,
    component: LightBoxAddon
  })
);

export { ExpandableNavigation, LightBox, ReportIssue, TextSize, techdocsModuleAddonsContribPlugin };
//# sourceMappingURL=plugin.esm.js.map
